module.exports = __webpack_public_path__ + "img/acid-projectile-purple-shadow.f6043403.png";